import { apiClient, authStore } from './client'

export type User = {
  id?: number
  username: string
  display_name: string
  email?: string | null
  is_admin: boolean
  is_active?: boolean
  photo?: string | null
}

type LoginResponse = User & {
  access_token: string
  token_type?: string
}

export async function login(username: string, password: string): Promise<User> {
  const { data } = await apiClient.post<LoginResponse>('/auth/login', { username, password })
  authStore.setToken(data.access_token)
  return { username: data.username, display_name: data.display_name, is_admin: data.is_admin }
}

export async function me(): Promise<User> {
  const { data } = await apiClient.get<User>('/auth/me')
  return data
}

export async function changePassword(current_password: string, new_password: string): Promise<void> {
  await apiClient.post('/auth/change-password', { current_password, new_password })
}

export function logout() {
  authStore.clear()
  window.location.href = '/'
}
